export default "__VITE_ASSET__OOi7E0LK__"